export default function PricingSection() {
  const plans = [
    { name: '但馬牛すき焼き', price: '12,000円〜' },
    { name: '鴨鍋', price: '9,000円〜' },
    { name: '猪豚鍋', price: '9,000円〜' },
    { name: 'かにちり鍋', price: '14,000円〜' },
  ];

  return (
    <section id="pricing" className="py-20 md:py-32 px-6 bg-[#f8f6f0] relative overflow-hidden">
      {/* Washi Texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="max-w-5xl mx-auto relative">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest-800 mb-3">
            料金案内
          </h2>
          <p className="text-gold-600 text-lg">Price List</p>
          <div className="w-24 h-1 bg-gold-600 mx-auto mt-6"></div>
        </div>

        {/* Main Pricing Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h3 className="font-serif text-2xl font-semibold text-forest-800 mb-6 text-center">
            料理プラン（税込・一泊二食付き）
          </h3>

          <div className="space-y-4">
            {plans.map((plan, index) => (
              <div
                key={index}
                className="flex items-center justify-between py-4 border-b border-gray-200 last:border-0"
              >
                <span className="text-forest-800 font-medium text-base md:text-lg">
                  {plan.name}
                </span>
                <span className="text-gold-600 font-bold text-lg md:text-xl">
                  {plan.price}
                </span>
              </div>
            ))}
          </div>

          <p className="text-gray-600 text-sm mt-6 text-center">
            ※ 季節・プラン企画によって料金が変動する場合がございます。
            <br />
            最新料金につきましては、ご予約時にお問い合わせください。
          </p>
        </div>

        {/* Children Pricing Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8">
          <h3 className="font-serif text-2xl font-semibold text-forest-800 mb-6 text-center">
            お子様料金
          </h3>

          <div className="space-y-4">
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-gold-600 text-xl"></i>
              </div>
              <div className="flex-1">
                <p className="text-forest-800 font-medium text-base">
                  小学生（二食付き）
                </p>
                <p className="text-gray-600 text-sm mt-1">大人料金の80%</p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-gold-600 text-xl"></i>
              </div>
              <div className="flex-1">
                <p className="text-forest-800 font-medium text-base">
                  幼児（二食付き・布団あり）
                </p>
                <p className="text-gray-600 text-sm mt-1">大人料金の60%</p>
              </div>
            </div>
          </div>
        </div>

        {/* Cancellation Policy */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h3 className="font-serif text-2xl font-semibold text-forest-800 mb-6 text-center">
            キャンセルポリシー
          </h3>

          <div className="space-y-3 mb-6">
            <p className="text-gray-700 text-sm leading-relaxed">
              ※ 予約人数の変更や、プランの変更が生じた場合には必ずお電話でご連絡ください。
            </p>
            <p className="text-gray-700 text-sm leading-relaxed">
              ※ 宿泊日直前、もしくは当日になっての予約内容変更につきましては、キャンセル料金をいただく場合がございますので予めご了承ください。
            </p>
          </div>

          <div className="bg-forest-50 rounded-xl p-6">
            <h4 className="font-semibold text-forest-800 mb-4 text-base">
              キャンセル料金
            </h4>
            <div className="space-y-3">
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="text-forest-800 text-sm">7〜4日前</span>
                <span className="text-gold-600 font-semibold text-sm">宿泊料の30%</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="text-forest-800 text-sm">3〜2日前</span>
                <span className="text-gold-600 font-semibold text-sm">宿泊料の50%</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="text-forest-800 text-sm">前日</span>
                <span className="text-gold-600 font-semibold text-sm">宿泊料の80%</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="text-forest-800 text-sm">当日</span>
                <span className="text-gold-600 font-semibold text-sm">宿泊料の100%</span>
              </div>
              <div className="flex justify-between items-center py-2">
                <span className="text-forest-800 text-sm">無断不泊</span>
                <span className="text-gold-600 font-semibold text-sm">宿泊料の100%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}